<ng-container *transloco="let t">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <div class="row gx-3 mt-4">
      <!-- Organisationsnummer, VAT -->
      <div class="col-md col-sm-12">
        <lib-input-container
          for="search-nu"
          [label]="t('worksite_search_number_label')"
          [markRequired]="true"
        >
          <input
            vinnova-text-input
            id="search-nu"
            formControlName="number"
            autocomplete="new-password"
            spellcheck="false"
            placeholder="123..."
            class="custom-placeholder"
          />
        </lib-input-container>
      </div>

      <!-- Namn -->
      <div class="col-md col-sm-12">
        <lib-input-container
          for="search-na"
          [label]="t('worksite_search_name_label')"
          [markRequired]="true"
        >
          <input
            vinnova-text-input
            id="search-na"
            formControlName="name"
            spellcheck="false"
            placeholder="abc..."
            class="custom-placeholder"
          />
        </lib-input-container>
      </div>

      <!-- Ort -->
      <div class="col-md col-sm-12">
        <lib-input-container
          for="search-ci"
          [label]="t('worksite_search_city_label')"
          [markRequired]="true"
        >
          <input
            vinnova-text-input
            id="search-ci"
            formControlName="city"
            spellcheck="false"
            placeholder="abc..."
            class="custom-placeholder"
          />
        </lib-input-container>
      </div>

      <div class="col-md col-sm-12">
        <lib-input-container
          [label]="t('worksite_search_country_label')"
          for="search-co"
          [autoWidth]="false"
          [markRequired]="true"
        >
          <lib-vinnova-dropdown
            [id]="'search-co'"
            [placeholder]="t('worksite_search_country_placeholder')"
            [items]="countries"
            formControlName="country"
            [required]="true"
          >
          </lib-vinnova-dropdown>
        </lib-input-container>
      </div>

      <div class="col-md-auto col-sm-12">
        <lib-input-container [markRequired]="true">
          <button
            vinnova-button-primary
            type="submit"
            [disabled]="isLoading$ | async"
          >
            {{ t('worksite_btn_search') }}
          </button>
        </lib-input-container>
      </div>
    </div>
    @if (isLoading$ | async) {
      <div class="loader my-2 mx-auto"></div>
    }
  </form>
</ng-container>
